import { memo } from "react";
import {
    TextBoldIcon,
    TextItalicIcon,
    TextStrikeIcon,
    TextUnderlineIcon,
} from "@/icons/text-format";
import { HStack } from "@/shared/ui/Stack";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./TextFormatMenuContent.module.css";

interface TextFormatMenuContentProps {
    onTextBoldButtonClick: () => void;
    onTextStrikeButtonClick: () => void;
    onTextItalicButtonClick: () => void;
    onTextUnderlineButtonClick: () => void;
    isBoldActive: boolean;
    isStrikeActive: boolean;
    isItalicActive: boolean;
    isUnderlineActive: boolean;
    showBold: boolean;
    showItalic: boolean;
    showUnderline: boolean;
}

export const TextFormatMenuContent = memo(function TextFormatMenuContent({
    onTextBoldButtonClick,
    onTextStrikeButtonClick,
    onTextItalicButtonClick,
    onTextUnderlineButtonClick,
    isBoldActive,
    isStrikeActive,
    isItalicActive,
    isUnderlineActive,
    showBold,
    showItalic,
    showUnderline,
}: TextFormatMenuContentProps) {
    const buttons = [
        {
            key: "bold",
            isVisible: showBold,
            isActive: isBoldActive,
            onClick: onTextBoldButtonClick,
            Icon: TextBoldIcon,
        },
        {
            key: "italic",
            isVisible: showItalic,
            isActive: isItalicActive,
            onClick: onTextItalicButtonClick,
            Icon: TextItalicIcon,
        },
        {
            key: "underline",
            isVisible: showUnderline,
            isActive: isUnderlineActive,
            onClick: onTextUnderlineButtonClick,
            Icon: TextUnderlineIcon,
        },
        {
            key: "strike",
            isVisible: true,
            isActive: isStrikeActive,
            onClick: onTextStrikeButtonClick,
            Icon: TextStrikeIcon,
        },
    ];

    return (
        <HStack gap={2}>
            {buttons.map(({ key, isVisible, isActive, onClick, Icon }) =>
                isVisible ? (
                    <MenuButton key={key} onClick={onClick} isActive={isActive}>
                        <Icon className={isActive ? styles.activeIcon : ""} />
                    </MenuButton>
                ) : null,
            )}
        </HStack>
    );
});
